import Translate from "../translate";
import Title from "../title";
import { cookiePolicyHtml } from "./cookie-policy-content";

const CookiePolicyPT = ({ logged, setNavigation }) => {
  return (
    <div>
      <Title handleNavigation={() => setNavigation(null)}>
        <Translate text="Cookie Policy" />
      </Title>
      <div className="app__content wrapper wrapper-small text">
        {logged ? (
          <Translate html={cookiePolicyHtml} />
        ) : (
          <div className="html" dangerouslySetInnerHTML={{ __html: cookiePolicyHtml }} />
        )}
      </div>
    </div>
  );
};

export default CookiePolicyPT;
